import React from 'react'

const WorkExperiencePage = () => {
    return (
        <div className="vertical-flow center s-center">
            <h1>Work Experience Coming Soon....</h1>
        </div>
    )
}

export default WorkExperiencePage